import React from 'react'
import { useEffect, useState } from 'react'
import { View } from '@instructure/ui-view'
import { Flex } from '@instructure/ui-flex'
import { Spinner } from '@instructure/ui-spinner'
import { connect } from 'react-redux'
import { IconAddLine, IconDragHandleLine } from '@instructure/ui-icons'
import { deleteEnrollment, getEnrollment } from '../../actions/courses'
import { setEnrollmentAlert } from '../../actions/sections'
import { ErrorBillBoard } from '@oxctl/ui-lti'
import { Text } from '@instructure/ui-text'
import { Tooltip } from '@instructure/ui-tooltip'
import { SourceContainer } from '../dragAndDrop/SourceContainer.jsx'
import { Popover } from '@instructure/ui-popover'
import { setSectionEnrollment } from '../../actions/sections'
import { getHighestEnrollmentRoleId } from '../../utils/commonFunctions'
import { TargetContainer } from '../dragAndDrop/TargetContainer.jsx'
import { IconButton } from '@instructure/ui-buttons'
import { List } from '@instructure/ui-list'
import TruncateSection from '../truncateSection/TruncateSection.jsx'

const ManageUsers = ({
   token,
   users,
   courseId,
   sections,
   deleteEnrollment,
   filteredUsers,
   setSectionEnrollment,
   enrollments,
   getEnrollment,
   setEnrollmentAlert
 }) => {

  const [showContent, setShowContent] = useState(false);
  const [loadedUsers, setLoadedUsers] = useState([]);

  // check is token is needed, valid or expired
  useEffect(() => {
    const {result } = users

    if(result && result.data) {
      setLoadedUsers(result.data || []);
    }
  }, [users, filteredUsers])

  const handleAddToSection = (e, user, section) => {
    getEnrollment(courseId, token);
    if(enrollments) {
      const roleId = getHighestEnrollmentRoleId(user.enrollments)
      if(user && roleId && token) {
        setSectionEnrollment(section, user.id, roleId, token)
        setEnrollmentAlert(true)
      }
    }
    setShowContent(false)
  }

  // user is loading data
  if(!loadedUsers.length && users && users.working) {
    return <Spinner renderTitle="Loading"/>
  }

  return (
    <ErrorBillBoard message={users?.error?.message}>
      <TargetContainer onDrop={(user, enrolledId) => {enrolledId && deleteEnrollment(enrolledId, courseId, token)}} type="fromUsers">
        <View as="div" display="block">
          <List isUnstyled aria-labelledby="users-header">
            {loadedUsers.map(user =>
              <List.Item key={user.id}>
                <SourceContainer object={user} type='fromUsers' >
                  <View display="block" borderWidth="small" margin="x-small x-small x-small none" padding="x-small" borderRadius="medium">
                    <Flex justifyItems="space-between">
                      <Flex.Item shouldShrink>
                        <Tooltip renderTip={user.sis_user_id || ""} as="div">
                          <div tabIndex="0">
                            <IconDragHandleLine color="secondary" title="drag handle"/>
                            <Text weight="bold" size="small" data-testid='user-name'>{user.name}</Text>
                            <span aria-label={user.sis_user_id || ''}/>
                          </div>
                        </Tooltip>
                      </Flex.Item>
                      <Flex.Item>
                        <Popover
                          renderTrigger={<IconButton screenReaderLabel={`${user.name} - add to group`} withBackground={false} withBorder={false}><IconAddLine title={"add user"}/></IconButton>}
                          isShowingContent={showContent === user.id}
                          onShowContent={() => {
                            setShowContent(user.id)
                          }}
                          onHideContent={() => {
                            setShowContent(false)
                          }}
                          on="click"
                          screenReaderLabel="Popover Dialog to add users to section"
                          shouldContainFocus
                          shouldReturnFocus
                          shouldCloseOnDocumentClick
                          placement="start"
                          mountNode={() => document.getElementById('main')}
                          constrain="window"
                        >
                          <View maxHeight="400px" width="120px" as="div" background="primary" shadow="resting">
                            <View background="secondary" padding="x-small" borderWidth="small" borderRadius="medium medium 0 0" borderBottom="none" as="div">
                              <Text size="x-small" id='add-to-section-title'>
                                <Text weight="bold">{user.name}</Text>
                                <Text> - Add to Section</Text>
                              </Text>
                            </View>
                            <View
                              as="div"
                              padding="xxx-small small xxx-small"
                              overflowY="auto"
                              borderWidth="small"
                              borderRadius="0 0 medium medium"
                              background="primary"
                            >
                              <List isUnstyled itemSpacing="x-small" aria-labelledby="add-to-section-title">
                                {sections.map(sect =>
                                  <List.Item key={sect.id}>
                                    <TruncateSection handleAddToSection={handleAddToSection} user={user} sect={sect}/>
                                  </List.Item>
                                )}
                              </List>
                            </View>
                          </View>
                        </Popover>
                      </Flex.Item>
                    </Flex>
                  </View>
                </SourceContainer>
              </List.Item>
            )}
          </List>
          {!loadedUsers?.length && <Text>No users found</Text>}
        </View>
      </TargetContainer>
    </ErrorBillBoard>
  );
}

const mapStateToProps = (state) => {
    const {userAccess: {jwtToken}, courses: { users, sections, enrollments }, canvas: {canvasCourse} } = state;

    return {
        token: jwtToken,
        courseId: canvasCourse && canvasCourse.courseId,
        users,
        sections: (sections && sections.result && sections.result.data) || [],
        enrollments: (enrollments && enrollments.result && enrollments.result.data) || []
    }
}

export default connect(mapStateToProps, {setSectionEnrollment, deleteEnrollment, getEnrollment, setEnrollmentAlert})(ManageUsers);